// 登入註冊彈窗
'use client';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setShowLoginModal } from '@/slices/popSlice';

import EmailLogin from './EmailLogin'; // 信箱登入流程
import LoginSelect from './LoginSelect'; // 登入方式選擇

const LoginModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    // 信箱登入
    const [showMail, setShowMail] = useState(false);

    return (
        <div className="modal">
            <div className="relative !overflow-visible">
                <div className="relative bg-white z-[1] w-[400px] max-w-full rounded-t-[8px] rounded-b-[12px] p-[40px] usx:p-[30px] uxs:!px-[20px]">
                    {showMail ? (
                        // 信箱登入
                        <EmailLogin setShowMail={setShowMail} t={t} />
                    ) : (
                        //  登入方式選擇
                        <LoginSelect setShowMail={setShowMail} t={t} />
                    )}
                </div>

                {/* 背景色 */}
                <div className="absolute z-[-1] w-full h-[15px] top-[-6px] left-0 bg-loa rounded-t-[12px]" />
            </div>

            <div />

            {/* 關閉用彈窗 */}
            <div
                className="close-bg"
                onClick={() => {
                    dispatch(setShowLoginModal(false));
                    setShowMail(false);
                }}
            />
        </div>
    );
};

export default LoginModal;
